import { Link } from "react-router-dom";
import { siteIntro } from "@/mocks/home";

export default function SiteIntro() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
              <i className="ri-information-line leading-none"></i>
              平台简介
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              {siteIntro.title}
            </h2>
            <div className="mt-4 space-y-3">
              {siteIntro.paragraphs.map((p) => (
                <p key={p} className="text-sm leading-relaxed text-foreground-700 md:text-base">
                  {p}
                </p>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line leading-none"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {siteIntro.stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6"
              >
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{stat.value}</p>
                <p className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}